import api from './client'
import type { PaginatedResponse } from './leads'

export interface RelinkOrphaned {
  sourceLead: {
    id: string
    firstName: string
    lastName: string
    currentDealId: string | null
  }
}

export interface Deal {
  id: string
  companyId: string
  title: string
  status: string
  // Copied from the lead at conversion time; null for deals created directly.
  source: string | null
  value: number | null
  currency: string
  contactId: string | null
  organizationId: string | null
  assignedTo: string | null
  assignedUser?: { id: string; firstName: string; lastName: string }
  customFields: Record<string, unknown>
  slaDeadline: string | null
  slaBreahed: boolean
  closedAt: string | null
  expectedCloseDate: string | null
  createdAt: string
  updatedAt: string
  deletedAt?: string | null
  // Set by GET /:id and POST /:id/restore. Non-null when the source
  // lead has been re-converted to a different deal — UI shows a banner.
  relinkOrphaned?: RelinkOrphaned | null
}

export const dealsApi = {
  list: (companyId: string, params: Record<string, unknown> = {}) =>
    api.get<PaginatedResponse<Deal>>(`/companies/${companyId}/deals`, { params }),
  get: (companyId: string, id: string) =>
    api.get<Deal>(`/companies/${companyId}/deals/${id}`),
  create: (companyId: string, dto: Partial<Deal>) =>
    api.post<Deal>(`/companies/${companyId}/deals`, dto),
  update: (companyId: string, id: string, dto: Partial<Deal>) =>
    api.patch<Deal>(`/companies/${companyId}/deals/${id}`, dto),
  remove: (companyId: string, id: string) =>
    api.delete(`/companies/${companyId}/deals/${id}`),
  restore: (companyId: string, id: string) =>
    api.post<Deal>(`/companies/${companyId}/deals/${id}/restore`),
  updateStage: (companyId: string, id: string, status: string) =>
    api.patch<Deal>(`/companies/${companyId}/deals/${id}/stage`, { status }),
  export: (companyId: string, params: Record<string, unknown> = {}) =>
    api.get(`/companies/${companyId}/deals/export`, { params, responseType: 'blob' }),
}
